/* DreamBrothers · "See it on your wall" — caricatore leggero.
 * Non scarica niente finche' il cliente non mostra interesse: al primo hover/tocco del pulsante
 * pre-carica editor, stanza iniziale e design, cosi' l'apertura e' istantanea.
 */
(function () {
  'use strict';
  if (window.__dbwpBoot) return;
  window.__dbwpBoot = true;

  var editorP = null;
  function loadEditor(cfg) {
    if (window.DBWallEditor) return Promise.resolve();
    if (editorP) return editorP;
    var css = new Promise(function (res) {
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = cfg.editorCss;
      l.onload = res; l.onerror = res; document.head.appendChild(l);
    });
    var js = new Promise(function (res, rej) {
      var s = document.createElement('script'); s.src = cfg.editorJs; s.async = true;
      s.onload = res; s.onerror = function () { editorP = null; rej(new Error('editor')); }; document.head.appendChild(s);
    });
    editorP = Promise.all([css, js]);
    return editorP;
  }
  function sized(url, w) {
    if (!url || /[?&]width=/.test(url) || !/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url;
    return url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  var warmed = {};
  function warm(cfg) {
    loadEditor(cfg).catch(function () { });
    [cfg.assetBase + 'db-room-' + (cfg.startRoom || 'arch') + '.webp', sized(cfg.designUrl, 1800)].forEach(function (u) {
      if (!u || warmed[u]) return; warmed[u] = 1; var i = new Image(); i.decoding = 'async'; i.src = u;
    });
  }
  function pageVariant(form) {
    try { var v = new URL(location.href).searchParams.get('variant'); if (v) return v; } catch (e) { }
    var i = form && form.querySelector('[name="id"]');
    return i && i.value ? i.value : null;
  }

  function init(root) {
    if (root.__dbwp) return; root.__dbwp = true;
    var cfgEl = root.querySelector('script[data-dbwp-config]'), btn = root.querySelector('[data-dbwp-open]');
    if (!cfgEl || !btn) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!cfg.product || !cfg.product.variants || !cfg.product.variants.length || !cfg.designUrl) { root.hidden = true; return; }
    var box = root.closest('.product-form__buy-buttons') || root.parentElement;
    var form = (box && box.querySelector('form[is="product-form"], form[action*="/cart/add"]')) || document.querySelector('form[is="product-form"]');
    var ctx = { form: form, selectedVariantId: null };
    // stessa forma dell'Add to cart del tema (pillola, angoli...), ma resta un pulsante secondario
    var atc = box && box.querySelector('button[type="submit"], [name="add"]');
    if (atc) { var rad = getComputedStyle(atc).borderRadius; if (rad && rad !== '0px') btn.style.borderRadius = rad; }
    if (form) form.addEventListener('variant:changed', function (e) { if (e.detail && e.detail.variant) ctx.selectedVariantId = e.detail.variant.id; });
    function onIntent() { warm(cfg); }
    btn.addEventListener('pointerenter', onIntent, { once: true });
    btn.addEventListener('touchstart', onIntent, { once: true, passive: true });
    btn.addEventListener('focus', onIntent, { once: true });
    function open(opts) {
      btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
      ctx.selectedVariantId = ctx.selectedVariantId || pageVariant(form);
      loadEditor(cfg).then(function () {
        btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
        window.DBWallEditor.open(cfg, ctx, opts || {});
      }).catch(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
    }
    btn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    // arrivo dal QR del desktop: apre direttamente l'AR sul telefono
    var m = location.hash.match(/dbwp-ar=(\d+)/);
    if (m) open({ variantId: m[1], ar: true });
  }
  function scan() { Array.prototype.forEach.call(document.querySelectorAll('[data-dbwp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
